<template>
  <div v-if="value" class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <div class="trip-login-wrap">
        <h3>{{ t('updateRequired') }}</h3>
        
        <p class="update-message">
          {{ t('updateRequiredMessage') }}
        </p>
        
        <div class="trip-login-bottom-btn">
          <button 
            @click="proceedWithUpdate" 
            id="trip-login-btn"
          >
            {{ t('loginAgain') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { translationMixin } from "@/mixins/translationMixin";

export default {
  name: "UpdateNotification",
  mixins: [translationMixin],
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions([
      "appLogOut",
      "showModal",
      "openLoginForm"
    ]),
    
    closeModal() {
      // Don't allow closing by clicking outside - this is a required action
      return;
    },
    
    proceedWithUpdate() {
      // Hide modal and logout user
      this.showModal('');
      this.appLogOut();
      // Open login popup
      this.openLoginForm();
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.modal-content {
  background: #FFFFFF;
  box-shadow: 4px 4px 4px rgb(0 0 0 / 10%);
  border-radius: 25px;
  max-width: 400px;
  width: 100%;
  padding: 30px;
}

.trip-login-wrap {
  text-align: center;
}

.trip-login-wrap h3 {
  font-weight: 800;
  font-size: 18px;
  line-height: 21px;
  color: #2E2E3A;
  margin-bottom: 15px;
  text-align: center;
}

.update-message {
  color: #666;
  margin-bottom: 20px;
  line-height: 1.5;
  text-align: center;
  font-size: 14px;
}

.trip-login-bottom-btn {
  margin-top: 25px;
}

button#trip-login-btn {
  width: 100%;
  height: 30px;
  background: #07A0C3;
  border-radius: 22px;
  border: none;
  font-weight: 500;
  font-size: 12px;
  color: white;
  margin-top: 15px;
}

button#trip-login-btn:hover {
  background-color: #0596b7;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(7, 160, 195, 0.3);
}

/* Responsive design */
@media (max-width: 576px) {
  .modal-content {
    margin: 10px;
    padding: 20px;
  }
}
</style>

